import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useRef, useState } from 'react';
import { Button, Column, Popover, Row, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetEditTitlePopoverTID = (parentTestId)=>getTestIds(parentTestId);
export const EditTitlePopover = (param)=>{
    let { anchorEl, initialValue, onSave, onClose, testId } = param;
    const { t } = useLocaleKeys();
    const testIds = useMemo(()=>GetEditTitlePopoverTID(testId), [
        testId
    ]);
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(false);
    const inputRef = useRef(null);
    const handleSave = useCallback(()=>{
        const trimmed = value.trim();
        if (!trimmed) {
            setError(true);
            return;
        }
        onSave(trimmed);
        onClose();
    }, [
        value,
        onSave,
        onClose
    ]);
    const handleChange = useCallback((e)=>{
        const newValue = e.target.value;
        setValue(newValue);
        if (newValue.trim()) {
            setError(false);
        }
    }, []);
    const handleKeyDown = useCallback((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSave();
        } else if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            onClose();
        }
    }, [
        handleSave,
        onClose
    ]);
    return /*#__PURE__*/ _jsx(Popover, {
        open: true,
        anchorEl: anchorEl,
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        },
        transformOrigin: {
            vertical: 'top',
            horizontal: 'left'
        },
        children: /*#__PURE__*/ _jsxs(Column, {
            testId: testIds.EditTitlePopoverTestIds.Root(),
            padding: "16px",
            onKeyDown: handleKeyDown,
            style: {
                minWidth: 280
            },
            children: [
                /*#__PURE__*/ _jsx(TextField, {
                    testId: testIds.EditTitlePopoverTestIds.TitleField(),
                    label: t.customPages.editTitle.label(),
                    value: value,
                    onChange: handleChange,
                    error: error,
                    helperText: error ? t.customPages.editTitle.emptyError() : undefined,
                    inputRef: inputRef,
                    autoFocus: true
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    justifyContent: "end",
                    style: {
                        marginTop: 12
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            testId: testIds.EditTitlePopoverTestIds.CancelButton(),
                            variant: "text",
                            onClick: onClose,
                            children: t.customPages.editTitle.cancel()
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            testId: testIds.EditTitlePopoverTestIds.SaveButton(),
                            variant: "contained",
                            onClick: handleSave,
                            children: t.customPages.editTitle.save()
                        })
                    ]
                })
            ]
        })
    });
};
